import { useEffect, useState } from "react"
import { getContactPage } from "../lib/api"
import { EMPTY_CONTACT_PAGE, contactPageFromServer, contactPagesEqual } from "../components/ContactPageFields"

// A saved code's hosted contact page (#332) for the two edit surfaces
// (EditCodeModal, EditDestination). The fields load from
// GET /api/v1/qr_codes/:token/contact_page when the Contact page kind is
// picked: at once for a code that opens its page, on the pick for one that
// doesn't (it may have kept a page from before it was pointed at a website).
//
// `hosted` is whether the Contact page kind is picked; `exists` whether the
// code has a live page at all (so Remove page details can show).
export default function useContactPage(code) {
  const [hosted, setHosted] = useState(Boolean(code.contact_page))
  const [page, setPage] = useState(EMPTY_CONTACT_PAGE)
  const [original, setOriginal] = useState(null)
  const [state, setState] = useState("idle") // idle | loading | ready | error
  const [errors, setErrors] = useState(null)

  useEffect(() => {
    if (!hosted || state !== "idle") return
    let cancelled = false
    setState("loading")
    getContactPage(code.token)
      .then((body) => {
        if (cancelled) return
        const fields = body ? contactPageFromServer(body.contact_page) : EMPTY_CONTACT_PAGE
        setOriginal(body ? fields : null)
        setPage(fields)
        setState("ready")
      })
      .catch(() => { if (!cancelled) setState("error") })
    return () => { cancelled = true }
  }, [hosted, state, code.token])

  return {
    hosted,
    setHosted: (next) => { setHosted(next); setErrors(null) },
    page,
    setPage,
    ready: state === "ready",
    failed: state === "error",
    exists: Boolean(original) || Boolean(code.contact_page),
    // A new page, or changed fields, needs a PUT.
    dirty: state === "ready" && (!original || !contactPagesEqual(page, original)),
    errors,
    setErrors,
  }
}
